// service_worker_utils.js

/**
 * Registers a background sync event with the service worker for uploading to S3.
 * This function waits for the existing service worker to be ready, then registers
 * a sync event with the tag 'upload-to-s3'. This event will trigger the service
 * worker's sync event listener to process any queued uploads.
 */
export async function triggerBackgroundSync(tag = 'upload-to-s3') {
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      try {
        const registration = await navigator.serviceWorker.ready;
        await registration.sync.register(tag);
        console.log('Background sync registered for S3 upload.');
      } catch (err) {
        console.error('Error registering background sync:', err);
      }
    } else {
      console.warn('Background sync is not supported in this browser.');
    }
  }
  